import { render } from "./form_remediators.vue?vue&type=template&id=cb2bc648"
import script from "./form_remediators.vue?vue&type=script&lang=js"
export * from "./form_remediators.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__